import { Crm3Contacts } from "@/components/crm-demos/crm-3-contacts"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-3")({
  component: Crm3Page,
  head: () => ({ meta: [{ title: "CRM 3 · Contacts" }] }),
});

function Crm3Page() {
  return <Crm3Contacts />
}
